import type { ReactElement } from 'react';

import { AppImages } from '@/config/appImages';

import styles from './AppBackground.module.css';

/**
 * Перенос `lib/src/presentation/widgets/app_background.dart`.
 *
 * Фон приложения — один на все экраны, под навигатором.
 *
 * Раньше каждый экран рисовал его сам внутри `BackgroundWrapper`: на время
 * перехода на экране было два размытых фона, а сквозь гаснущие страницы
 * проступала светлая подложка перехода. Теперь фон не участвует в переходах
 * вовсе, страницы прозрачные.
 *
 * Слои те же, что были в `BackgroundWrapper`: белый фон Scaffold, SVG
 * с непрозрачностью 0.9 и размытие поверх.
 *
 * Обе картинки отрисованы всегда, а видимую выбирает `data-orientation` на
 * `:root` — так перекрёстное затухание (400 мс, easeIn/easeOut, как у
 * AnimatedSwitcher) делает браузер, без перерисовки React.
 */
export function AppBackground(): ReactElement {
  return (
    <div className={styles.root} aria-hidden="true">
      <div className={styles.blur}>
        <img
          className={[styles.image, styles.landscape].join(' ')}
          src={AppImages.landscapeBackground}
          alt=""
          draggable={false}
        />
        <img
          className={[styles.image, styles.portrait].join(' ')}
          src={AppImages.portraitBackground}
          alt=""
          draggable={false}
        />
      </div>
    </div>
  );
}
